import React from 'react';

import AddressSuggestInput from './AddressSuggestInput';
import ActivityTypeSelect from './ActivityTypeSelect';

export const createEmptyLodgingDraft = () => ({
  lodging_name: '',
  lodging_type: '',
  address: '',
  lat: null,
  lon: null,
  start_date: '',
  end_date: '',
  check_in_time: '',
  check_out_time: '',
  booking_url: '',
  booking_image_url: '',
});

export default function LodgingForm({
  draft,
  setDraft,
  lodgingTypeOptions,
  activityTypes,
  lodgingCategoryId,
  onTypeCreated,
  openNativePicker,
  showSubmit,
  submitLabel,
  onSubmit,
}) {
  const typeOptions = Array.isArray(lodgingTypeOptions) ? lodgingTypeOptions : [];
  const d = draft || createEmptyLodgingDraft();
  const useActivityTypeSelect = lodgingCategoryId && Array.isArray(activityTypes) && activityTypes.length;

  return (
    <div className="tp-grid" style={{ marginTop: 10, gap: 12 }}>
      <div className="tp-col-6">
        <div className="tp-field">
          <span className="tp-label">Name</span>
          <input
            type="text"
            placeholder="e.g., Hotel Central"
            value={d.lodging_name || ''}
            onChange={e => setDraft(prev => ({ ...prev, lodging_name: e.target.value }))}
          />
        </div>
      </div>

      <div className="tp-col-6">
        <div className="tp-field">
          <span className="tp-label">Type</span>
          {useActivityTypeSelect ? (
            <ActivityTypeSelect
              types={activityTypes}
              categoryId={lodgingCategoryId}
              typeId={d.lodging_type}
              onTypeChange={v => setDraft(prev => ({ ...prev, lodging_type: v }))}
              onTypeCreated={newType => {
                onTypeCreated?.(newType);
                setDraft(prev => ({ ...prev, lodging_type: newType.type_name }));
              }}
              placeholderType="Select Type"
              showCategory={false}
              valueKey="type_name"
            />
          ) : (
            <select
              value={d.lodging_type || ''}
              onChange={e => setDraft(prev => ({ ...prev, lodging_type: e.target.value }))}
            >
              <option value="">Select Type</option>
              {typeOptions.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          )}
        </div>
      </div>

      <div className="tp-col-12">
        <div className="tp-field">
          <span className="tp-label">Address</span>
          <AddressSuggestInput
            placeholder="Start typing an address or place name"
            value={d.address || ''}
            onChange={(v) => setDraft(prev => ({ ...prev, address: v, lat: null, lon: null }))}
            onSelect={(s) => setDraft(prev => ({
              ...prev,
              address: s.display_name || s.label || prev.address,
              lat: s.lat != null ? s.lat : prev.lat,
              lon: s.lon != null ? s.lon : prev.lon,
            }))}
          />
        </div>
      </div>

      <div className="tp-col-12">
        <div className="tp-field">
          <span className="tp-label">Link (optional)</span>
          <input
            type="url"
            placeholder="https://..."
            value={d.booking_url || ''}
            onChange={e => setDraft(prev => ({ ...prev, booking_url: e.target.value }))}
          />
        </div>
      </div>

      <div className="tp-col-12">
        <div className="tp-field">
          <span className="tp-label">Image URL (optional)</span>
          <input
            type="url"
            placeholder="https://..."
            value={d.booking_image_url || ''}
            onChange={e => setDraft(prev => ({ ...prev, booking_image_url: e.target.value }))}
          />
        </div>
      </div>

      <div className="tp-col-6">
        <div className="tp-field">
          <span className="tp-label">Start Date</span>
          <input
            type="date"
            value={d.start_date || ''}
            onClick={openNativePicker}
            onChange={e => {
              const v = e.target.value;
              setDraft(prev => ({
                ...prev,
                start_date: v,
                end_date: prev.end_date && v && prev.end_date < v ? '' : prev.end_date,
              }));
            }}
          />
        </div>
      </div>

      <div className="tp-col-6">
        <div className="tp-field">
          <span className="tp-label">End Date</span>
          <input
            type="date"
            min={d.start_date || ''}
            value={d.end_date || ''}
            onClick={openNativePicker}
            onChange={e => {
              const v = e.target.value;
              setDraft(prev => {
                const start = prev.start_date;
                if (start && v && v < start) return prev;
                return { ...prev, end_date: v };
              });
            }}
          />
        </div>
      </div>

      <div className="tp-col-6">
        <div className="tp-field">
          <span className="tp-label">Check-in Time</span>
          <input
            type="time"
            step="60"
            value={d.check_in_time || ''}
            onClick={openNativePicker}
            onChange={e => setDraft(prev => ({ ...prev, check_in_time: e.target.value }))}
          />
        </div>
      </div>

      <div className="tp-col-6">
        <div className="tp-field">
          <span className="tp-label">Check-out Time</span>
          <input
            type="time"
            step="60"
            value={d.check_out_time || ''}
            onClick={openNativePicker}
            onChange={e => setDraft(prev => ({ ...prev, check_out_time: e.target.value }))}
          />
        </div>
      </div>

      {showSubmit ? (
        <div className="tp-col-12">
          <div className="tp-row">
            <button onClick={onSubmit}>{submitLabel || 'Add Lodging'}</button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
